import { render } from "./AddressModify.vue?vue&type=template&id=cfd3837c"
import script from "./AddressModify.vue?vue&type=script&lang=js"
export * from "./AddressModify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__